export default __webpack_public_path__ + "static/media/Pavlin.57cffa5c.mp4";